import { SafeAreaView as RSafeAreaView } from 'react-native'

import { motify } from '../core'

export const SafeAreaView = motify(RSafeAreaView)()
